(function(){
  // Utilities
  const el = (sel, ctx=document) => ctx.querySelector(sel);
  const els = (sel, ctx=document) => Array.from(ctx.querySelectorAll(sel));

  const section = document.getElementById('build-bundle-section');
  if(!section) return;

  // Variant map (4 vs 9)
  const variantMapEl = document.getElementById('bb-variant-map');
  const variant4 = Number(variantMapEl.getAttribute('data-variant-4-id')) || null;
  const variant9 = Number(variantMapEl.getAttribute('data-variant-9-id')) || null;
  const variant4Price = Number(variantMapEl.getAttribute('data-variant-4-price')) || null;
  const variant9Price = Number(variantMapEl.getAttribute('data-variant-9-price')) || null;
  const priceEl = document.getElementById('variant-price');

  // Initial state
  let boxSize = 4;
  let slots = []; // array of {productId, variantId, title, image}
  let picks = {}; // keyed by productId -> {productId, variantId, title, image, qty, inventory}
  let price = variant4Price || 0;
  priceEl.innerText = price ? `$${(price/100).toFixed(2)}` : '';

  // DOM refs
  const grid = el('#bb-grid');
  const flavourList = el('#bb-flavour-list');
  const addBtn = el('#bb-add-to-cart');
  const errorBox = el('#bb-error');
  const sizeButtons = els('.bb-size-btn');

  function readFlavourCards() {
    // Parse DOM to initialize picks and inventory
    const cards = els('.bb-flavour-card', flavourList);
    const flavours = cards.map(card => ({
      el: card,
      productId: card.dataset.productId,
      variantId: Number(card.dataset.variantId),
      title: card.dataset.title,
      image: card.dataset.image,
      available: card.dataset.available === "true",
      inventory: parseInt(card.dataset.inventory || '0', 10)
    }));
    return flavours;
  }

  // Render grid
  function renderGrid(){
    grid.dataset.size = boxSize;
    grid.innerHTML = '';
    for(let i=0;i<boxSize;i++){
      const slot = document.createElement('div');
      slot.className = 'bb-slot';
      slot.dataset.index = i;
      if(slots[i]){
        const img = document.createElement('img');
        img.src = slots[i].image;
        img.alt = slots[i].title;
        slot.appendChild(img);

        const removeBtn = document.createElement('button');
        removeBtn.className = 'bb-remove-slot';
        removeBtn.type = 'button';
        removeBtn.title = 'Remove';
        removeBtn.innerText = '✕';
        removeBtn.style = 'position:absolute; top:4px; right:4px; background:transparent; border:none; font-size:16px; cursor:pointer;';
        removeBtn.addEventListener('click', ()=> {
          decrementPick(slots[i].productId);
        });
        slot.appendChild(removeBtn);
      } else {
        slot.innerText = '';
      }
      grid.appendChild(slot);
    }
    updateFlavourControls();
  }

  // Update counters on flavour cards
  function updateFlavourControls(){
    const cards = els('.bb-flavour-card', flavourList);
    cards.forEach(card => {
      const pid = card.dataset.productId;
      const control = card.querySelector('.bb-flavour-controls');
      const countEl = card.querySelector('.bb-count');
      const incBtn = card.querySelector('[data-action="increment"]');
      const decBtn = card.querySelector('[data-action="decrement"]');

      const pick = picks[pid];
      const qty = pick ? pick.qty : 0;
      countEl.innerText = qty;

      // Show controls if any picks or clickable
      if(!card.classList.contains('bb-soldout')) {
        control.setAttribute('aria-hidden', 'false');
      } else {
        control.setAttribute('aria-hidden', 'true');
      }

      // enable/disable inc based on remaining slots and inventory
      incBtn.disabled = (Object.values(picks).reduce((s,p)=>s+p.qty,0) >= boxSize) || (pick && pick.qty >= pick.inventory);
      decBtn.disabled = qty <= 0;
    });
  }

  // Add pick (one unit)
  function incrementPick(productId){
    const card = flavourList.querySelector(`[data-product-id="${productId}"]`);
    if(!card) return;
    if(card.classList.contains('bb-soldout')) return;
    const variantId = Number(card.dataset.variantId);
    const inventory = parseInt(card.dataset.inventory||'0',10);

    const totalPicked = Object.values(picks).reduce((s,p)=>s+p.qty,0);
    if(totalPicked >= boxSize){
      showError(`You can only pick ${boxSize} bonbons.`);
      return;
    }

    const existing = picks[productId] || { productId, variantId, title: card.dataset.title, image: card.dataset.image, qty: 0, inventory };
    if(existing.qty + 1 > inventory){
      showError(`Only ${inventory} left of ${existing.title}.`);
      return;
    }

    existing.qty += 1;
    picks[productId] = existing;

    // fill next empty slot with this pick
    const nextEmpty = slots.findIndex(s => !s);
    if(nextEmpty === -1){
      // Shouldn't happen due to check, but guard
      showError(`No empty slots left.`);
      return;
    }
    slots[nextEmpty] = { productId, variantId, title: existing.title, image: existing.image };

    renderGrid();
    clearError();
  }

  function decrementPick(productId){
    const pick = picks[productId];
    if(!pick || pick.qty <= 0) return;

    // remove one from picks
    pick.qty -= 1;
    if(pick.qty === 0) delete picks[productId];
    else picks[productId] = pick;

    // remove one slot with that productId (last occurrence)
    for(let i=slots.length-1;i>=0;i--){
      if(slots[i] && slots[i].productId === productId){
        slots[i] = null;
        break;
      }
    }
    // compact slots to left (optional)
    const compacted = [];
    for(let i=0;i<slots.length;i++) if(slots[i]) compacted.push(slots[i]);
    while(compacted.length < boxSize) compacted.push(null);
    slots = compacted;

    renderGrid();
    clearError();
  }

  function clearSelections(){
    slots = Array(boxSize).fill(null);
    picks = {};
    renderGrid();
  }

  function showError(msg){
    if(errorBox) errorBox.textContent = msg;
  }
  function clearError(){ if(errorBox) errorBox.textContent = ''; }

  // Wire up flavour clicks and increment/decrement buttons
  function attachFlavourListeners(){
    const cards = els('.bb-flavour-card', flavourList);
    cards.forEach(card => {
      const pid = card.dataset.productId;
      const inc = card.querySelector('[data-action="increment"]');
      const dec = card.querySelector('[data-action="decrement"]');

      // If the merchant clicks anywhere on the card, treat as increment
      card.addEventListener('click', (ev) => {
        if(card.classList.contains('bb-soldout')) return;
        // Prevent click when clicking on the control buttons themselves - they have own handlers
        if(ev.target.closest('.bb-flavour-controls')) return;
        incrementPick(pid);
      });

      inc.addEventListener('click', (ev) => {
        ev.stopPropagation();
        incrementPick(pid);
      });
      dec.addEventListener('click', (ev) => {
        ev.stopPropagation();
        decrementPick(pid);
      });
    });
  }

  // Box size toggle listeners
  sizeButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const size = Number(btn.dataset.size);
      if(size === boxSize) return;
      boxSize = size;

    // Update price
    price = boxSize === 4 ? variant4Price : variant9Price;
    if(priceEl) priceEl.innerText = `$${(price/100).toFixed(2)}`;
      // When size changes, reset choices (simpler/safer)
      clearSelections();
      renderGrid();
      // adjust UI active state
      sizeButtons.forEach(b => b.classList.toggle('active', Number(b.dataset.size)===boxSize));
    });
  });

  // Add to cart: send parent variant ID + properties
  async function addToCart(){
    clearError();
    const totalPicked = Object.values(picks).reduce((s,p)=>s+p.qty,0);
    if(totalPicked !== boxSize){
      showError(`Please pick exactly ${boxSize} bonbons.`);
      return;
    }

    // Determine parent build variant id
    const variantId = (boxSize === 4 ? variant4 : variant9);
    if(!variantId){
      showError('Configuration error: variant missing.');
      return;
    }

    // Build properties
    // Example properties:
    // "Box size": "4"
    // "Flavours": "Hazelnut x2, Raspberry x2"
    const flavoursProp = Object.values(picks).map(p=> `${p.title} x${p.qty}`).join(', ');
    const props = {
      "Box size": String(boxSize),
      "Flavours": flavoursProp
    };

    const body = {
      items: [
        {
          id: variantId,
          quantity: 1,
          properties: props
        }
      ]
    };

    addBtn.disabled = true;
    addBtn.innerText = 'Adding...';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify(body)
      });
      if(!res.ok){
        const err = await res.json().catch(()=>({ description: 'Unknown error' }));
        showError(err.description || 'Failed to add to cart.');
        addBtn.disabled = false;
        addBtn.innerText = 'Add box to cart';
        return;
      }
      const data = await res.json();
      if (res.ok) {
        addBtn.innerText = 'Added!';
        addBtn.disabled = false;
      }
      // Optionally redirect to cart
      return
    } catch (e){
      showError('Network error. Try again.');
      addBtn.disabled = false;
      addBtn.innerText = 'Add box to cart';
    }
  }

function addFilterListener() {
  const e = document.getElementById('bb-filter-select');
  const flavours = Array.from(document.getElementsByClassName('bb-flavour-card'));

  if (!e || flavours.length === 0) return; // safety check

  e.addEventListener('change', (event) => {
    const value = event.target.value.toLowerCase();

    flavours.forEach(card => {
      // ensure card is an element and has dataset
      if (card instanceof HTMLElement && card.dataset.dietaryPreferences !== undefined) {
        const prefs = card.dataset.dietaryPreferences.toLowerCase(); // "dairy-free vegan"

        if (value === "all" || prefs.includes(value)) {
          card.style.display = "";
        } else {
          card.style.display = "none";
        }
      }
    });
  });
}
  

  // Initialize
  function init(){
    // set up initial slots
    slots = Array(boxSize).fill(null);

    attachFlavourListeners();
    addFilterListener();
    renderGrid();

    // hook add to cart
    addBtn.addEventListener('click', addToCart);
  }

  // Start
  init();

})();